import { render, staticRenderFns } from "./MyProfilePortfolio.vue?vue&type=template&id=304e21d4&scoped=true"
import script from "./MyProfilePortfolio.vue?vue&type=script&lang=js"
export * from "./MyProfilePortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e21d4",
  null
  
)

export default component.exports